module.exports = __webpack_public_path__ + "img/banner-en.fa57ed20.png";